var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-node-dom',{tag:"component",attrs:{"mConfig":_vm.mConfig}},[_vm._l((_vm.mConfig.children),function(item,index){return [_c('page-preview-dom',{key:index,attrs:{"mConfig":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }